(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('licences', {
            parent: 'entity',
            url: '/licences?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jotApp.licences.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/licences/licences.html',
                    controller: 'LicencesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licences');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('licences-detail', {
            parent: 'entity',
            url: '/licences/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jotApp.licences.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/licences/licences-detail.html',
                    controller: 'LicencesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('licences');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Licences', function($stateParams, Licences) {
                    return Licences.get({id : $stateParams.id});
                }]
            }
        })
        .state('licences.new', {
            parent: 'licences',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licences/licences-dialog.html',
                    controller: 'LicencesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('licences', null, { reload: true });
                }, function() {
                    $state.go('licences');
                });
            }]
        })
        .state('licences.edit', {
            parent: 'licences',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licences/licences-dialog.html',
                    controller: 'LicencesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Licences', function(Licences) {
                            return Licences.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('licences', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('licences.delete', {
            parent: 'licences',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/licences/licences-delete-dialog.html',
                    controller: 'LicencesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Licences', function(Licences) {
                            return Licences.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('licences', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
